import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
const WINGraph = () => {
	const options = {
		animationEnabled: true,
		exportEnabled: true,
		theme: "light1", // "light2", "dark1", "dark2"

		axisY: {
			minimum: 6,
			maximum: 10,
			suffix: "%",
			interval: 1,
		},
		axisX: {
			interval: 1,
			labelFormatter: function (e) {
				return e.value.toString(); // Convert the year to string without commas
			},
		},
		data: [{
			color: "#30B524",
			type: "line",
			toolTipContent: "{x}: {y}%",
			dataPoints: [
				{ x: 2015, y: 8.7 },
				{ x: 2016, y: 8.1 },
				{ x: 2017, y: 7.8 },
				{ x: 2018, y: 8.0 },
				{ x: 2019, y: 7.9 },
				{ x: 2020, y: 7.1 },
				{ x: 2021, y: 7.1 },
				{ x: 2022, y: 7.1 },
				{ x: 2023, y: 7.1 },
				{ x: 2024, y: 7.1 },
			]
		}]
	};

	return (
		<>
			<div className="GraphSection">
				<CanvasJSChart options={options} />
			</div>
		</>
	);
};

export default WINGraph;
